var map = {
	"./ar.json": [
		"mmgn",
		74
	],
	"./en.json": [
		"3z5P",
		73
	],
	"./es.json": [
		"kKBs",
		72
	],
	"./it.json": [
		"Azu4",
		71
	],
	"./pt.json": [
		"wB8c",
		70
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "xKvj";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./resources/lang lazy ^\.\/.*\.json$
// module id = xKvj
// module chunks = 75